import { HashRouter as Router, Switch, Route } from 'react-router-dom'
import Overview from './WatchlistsOverview'
import 'react-toastify/dist/ReactToastify.css'
import withOnlyAllowLoggedIn from 'components/generic/hoc/withOnlyAllowLoggedIn'
import PageWrapper from 'components/generic/containers/PageWrapper'
import { watchlistsModalsState } from 'constants/modals'
import { withModals } from 'hooks/use-modal'
import RenameWatchListModal from './modals/RenameWatchListModal'
import DeleteWatchListModal from './modals/DeleteWatchListModal'
import DetailView from './WatchlistDetail'
import CreateWatchlistModal from './modals/CreateWatchlistModal'
import ScrollToTop from 'components/generic/router/ScrollToTop'

export enum PageUrls {
  WatchLists = '/',
  DetailView = '/detail-view',
}

const WatchlistsRouter = () => {
  return (
    <>
      <Router hashType='noslash'>
        <ScrollToTop />
        <PageWrapper>
          <Switch>
            <Route exact path={PageUrls.DetailView + '/:id'}>
              <DetailView />
            </Route>

            <Route exact path={'/'}>
              <Overview />
            </Route>
          </Switch>
        </PageWrapper>
      </Router>
      <RenameWatchListModal />
      <DeleteWatchListModal />
      <CreateWatchlistModal />
    </>
  )
}

export default withOnlyAllowLoggedIn(withModals(WatchlistsRouter, watchlistsModalsState))
